import React from 'react'
import ReportView from '../components/ReportView'

function Report() {
  return (
    <ReportView />
  )
}

export default Report